export default "__VITE_ASSET__8NCOO9k4__"